import React from 'react'

import {
  useAccount,
  useActions,
  useQueryParams,
  useSubscriptions,
} from 'src/hooks'
import { getTotal } from 'src/helpers'
import Editor from 'src/editor/containers/Editor/Editor'
import { bulkReturnAddress } from 'src/app/constants'
import omit from 'lodash/omit'
import { CustomCardEditRoute } from '../routes/CustomCardEditRoute'
import { useCreateOrder } from 'src/react_query'
import { CreateOrderInput } from 'src/graphql/generated/graphql'

type Props = {
  cardId: string
  subroute?: CustomCardEditRoute
}

const Card: React.FC<Props> = props => {
  const { cardId, subroute } = props

  const createOrder = useCreateOrder()
  const actions = useActions()
  const account = useAccount()
  const { userBulkCardCost: bulkCardCost } = useSubscriptions()
  const { bulkOrderPromo } = useQueryParams()

  const handleSaveAndSend = async () => {
    const bulkOrderArgs: CreateOrderInput = bulkOrderPromo
      ? {
          bulkUpgradeCardQty: 20,
          returnAddress: account.shippingAddress
            ? bulkReturnAddress
            : undefined,
          bulkUpgradeShippingAddress: account.shippingAddress
            ? omit(account.shippingAddress, '__typename')
            : undefined,
        }
      : {}
    const {
      createOrder: { order },
    } = await createOrder.mutateAsync({
      order: { lines: [{ card: cardId }], ...bulkOrderArgs },
    })
    actions.openOrder(order.id)
  }

  const handleClose = () => {
    actions.openCatalog()
  }

  return (
    <Editor
      cardId={cardId}
      onAfterSave={handleSaveAndSend}
      onClose={handleClose}
      saveButtonLabel="Proceed to Cart"
      saveButtonBackground="#32b769"
      saveButtonColor="#FFFFFF"
      context={{
        headerText:
          subroute && subroute.path === CustomCardEditRoute.path
            ? 'Editing custom card'
            : undefined,
        footerLabel: card => (
          <>
            Total:{' '}
            {getTotal(
              card.cost,
              bulkOrderPromo
                ? {
                    bulkCardCost,
                    paperType: bulkOrderPromo.paperType,
                  }
                : undefined,
            )}
          </>
        ),
      }}
    />
  )
}

export default Card
